import styled from 'styled-components';

export default styled.div`
  .Section {
    padding-top: 64px !important;
    padding-bottom: 0 !important;
    @media (max-width: 768px) {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
  .Row:nth-of-type(2) > div {
    width: 86%;
    margin: auto;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .Row:nth-of-type(3) {
    width: 88%;
    margin: auto !important;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  div[class^='DotLine'] {
    display: none;
  }
`;
